window.filterChangeAxt = 0;

$(document).on("click", ".product__info-container", function (keya) {
  window.filterChangeAxt = 1;
  setTimeout(() => {
        window.filterChangeAxt = 0;
    }, "1500");
});

setTimeout(() => {
  const selectElement = document.querySelector("variant-radios");
  if(selectElement){
  selectElement.addEventListener("click", (event) => {
    
    var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-variant-id");
    setTimeout(() => {
       
        var variantId = document.querySelector('[name="id"]').value;
        document.getElementsByClassName("axt-cp-custom")[0].classList.add(variantId);
        document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldVariant);
        document.getElementsByClassName("axt-cp-custom")[0].setAttribute("axt-cp-variant-id", variantId);
    }, "700");

});
 }
}, "1000");